import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import Btn from "../../shared/button/Btn"
import InputCityTown from "../../shared/input/new/InputCityTown"
import InputText from "../../shared/input/new/InputText"
import InputSelect from "../../shared/input/new/InputSelect"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { createInspectionStationLocation } from "../../../features/admin3/admin3Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        height: 450px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        overflow-x: hidden;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .input-containers{
                display: flex;
                flex-direction: column;
                gap: 15px;
                .row{
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            padding-block: 10px;
            gap: 10px;
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
        }
    }
`

const directionOptions = [
    {
        text: "Tek Yön",
        bool: false
    },
    {
        text: "Çift Yön",
        bool: true
    }
]

const AddKarayollariIstasyonModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [cityTown, setCityTown] = useState(null)
    const [direction, setDirection] = useState(null)
    const [data, setData] = useState({
        location: "",
        lat: "",
        lng: "",
        stationName: ""
    })

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value})
    }

    const handleSubmit = () => {
        const addData = {
            city: cityTown.city,
            district: cityTown.town,
            location: data.location,
            direction: direction.bool,
            latitude: data.lat,
            longitude: data.lng,
            stationName: data.stationName
        }
        dispatch(createInspectionStationLocation(addData))
    }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"İstasyon Ekle"}/>
            <div className="content">
               <div className="input-containers">
                    <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"100%"} labelText="İl/İlçe" name={"cityTown"}/>
                    <InputText data={data?.location} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Lokasyon" name={"location"} />
                    <InputText data={data?.stationName} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="İstasyon Adı" name={"stationName"} />
                    <InputSelect data={direction?.text} setData={setDirection} inputWidth={"100%"} labelText="Yön" name={"direction"} initialOptions={directionOptions} />
                    <div className="row">
                        <InputText data={data?.lat} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Lat" name={"lat"} />
                        <InputText data={data?.lng} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Lng" name={"lng"} />
                    </div>
               </div>
            </div>
            <div className='button-grp'>
                <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={handleSubmit}>Ekle</Btn>
                <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Kapat</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AddKarayollariIstasyonModal